import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

import config from "./config1.json";
let cart = window.localStorage.getItem('cart');
let cartCount = window.localStorage.getItem('cartCount');

let wish = window.localStorage.getItem('wish');
let wishCount = window.localStorage.getItem('wishCount');

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    status: "",
    token: sessionStorage.getItem("token") || "",
    menus: sessionStorage.getItem("menus") || "",
    cart: cart ? JSON.parse(cart) : [],
    cartCount: cartCount ? parseInt(cartCount) : 0,

    wish: wish ? JSON.parse(wish) : [],
    wishCount: wishCount ? parseInt(wishCount) : 0,
  },

  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status
  },

  mutations: {
    saveCart(state) {
      window.localStorage.setItem('cart', JSON.stringify(state.cart));
      window.localStorage.setItem('cartCount', state.cartCount);
    },
    saveWish(state) {
      window.localStorage.setItem('wish', JSON.stringify(state.wish));
      window.localStorage.setItem('wishCount', state.wishCount);
    },
    addToWish(state, item) {
      let found = state.wish.find(product => product.itemId == item.itemId);

    if (found) {
        found.quantity ++;
        found.totalPrice = found.quantity * found.price;
    } else {
        state.wish.push(item);

        Vue.set(item, 'quantity', 1);
        Vue.set(item, 'totalPrice', item.price);
    }
      state.wishCount++;
      this.commit('saveWish');
    },

    addToCart(state, item) {
      let found = state.cart.find(product => product.itemId == item.itemId);

    if (found) {
        found.quantity ++;
        found.totalPrice = found.quantity * found.price;
    } else {
        state.cart.push(item);

        Vue.set(item, 'quantity', 1);
        Vue.set(item, 'totalPrice', item.price);
    }
      state.cartCount++;
      this.commit('saveCart');
    },

    minusToCart(state, item) {
      let found = state.cart.find(product => product.itemId == item.itemId);

    if (found) {
        found.quantity --;
        found.totalPrice = found.quantity * found.price;
    }
      state.cartCount--;
      this.commit('saveCart');
      //console.log(item.itemName);
    },

    count(state) {
      state.cart.splice(0, state.cart.length);
      state.cartCount = 0;
      this.commit('saveCart');
    },

    removeFromCart(state, item) {
      let index = state.cart.indexOf(item);
  
      if (index > -1) {
          let product = state.cart[index];
          state.cartCount -= product.quantity;
  
          state.cart.splice(index, 1);
      }
      this.commit('saveCart');
    },
    removeFromWish(state, item) {
      let index = state.wish.indexOf(item);
  
      if (index > -1) {
          let product = state.wish[index];
          state.wishCount -= product.quantity;
  
          state.wish.splice(index, 1);
      }
      this.commit('saveWish');
    },

    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, token, menus) {
      state.status = "success";
      state.token = token;
      state.menus = menus;
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.menus = "";
    }
  },
  actions: {
    login({ commit }, menus) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: config.API + "Token",
          data: menus,
          method: "POST"
        })
          .then(resp => {
             console.log(resp.data);
            const token = resp.data.token.value.token;
            const menus = resp.data.menus;
            const loggedInUserName = resp.data.loggedInUserName;
            const loggedInUserID = resp.data.loggedInUserID;
            const roles = resp.data.roles;
            sessionStorage.setItem("token", token);
            sessionStorage.setItem("loggedInUserName", loggedInUserName);
            sessionStorage.setItem("loggedInUserID", loggedInUserID);
            sessionStorage.setItem("roles", roles);
            sessionStorage.setItem("menus", JSON.stringify(menus));
            axios.defaults.headers.common["Authorization"] = token;
            commit("auth_success", token, menus);
            resolve(resp);
          })
          .catch(err => {
            commit("auth_error");
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("menus");
            sessionStorage.removeItem("loggedInUserID");
            reject(err);
          });
      });
    },
    submit({ commit }, menus) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: config.API + "Token2",
          data: menus,
          method: "POST"
        })
          .then(resp => {
            // console.log(resp.data.loggedInUserName);
            const token = resp.data.token.value.token;
            const menus = resp.data.menus;
            const loggedInUserName = resp.data.loggedInUserName;
            const loggedInUserID = resp.data.loggedInUserID;
            const roles = resp.data.roles;
            sessionStorage.setItem("token", token);
            sessionStorage.setItem("loggedInUserName", loggedInUserName);
            sessionStorage.setItem("loggedInUserID", loggedInUserID);
            sessionStorage.setItem("roles", roles);
            sessionStorage.setItem("menus", JSON.stringify(menus));
            axios.defaults.headers.common["Authorization"] = token;
            commit("auth_success", token, menus);
            resolve(resp);
          })
          .catch(err => {
            commit("auth_error");
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("menus");
            sessionStorage.removeItem("loggedInUserID");
            reject(err);
          });
      });
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        commit("logout");
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("menus");
        sessionStorage.removeItem("loggedInUserName");
        sessionStorage.removeItem("loggedInUserID");
        sessionStorage.removeItem("roles");
        delete axios.defaults.headers.common["Authorization"];
        resolve();
      });
    }
  }
});
